import React, { Component } from 'react';
import { graphql, compose } from 'react-apollo';
import { Alert, Table } from 'reactstrap';
import moment from 'moment';
import { QueryTransaction } from './querytrans';

const TransactionGQL = compose(
  graphql(QueryTransaction, {
    name: 'transs',
    options: (ownProps) => ({
      variables: {
        querytype: ownProps.operator,
        queryvalue: ownProps.value,
      },
    }),
  })
);

const formdate = (value) => moment(value).format('DD MMM YYYY HH:mm:ss');

class TransTable extends Component {
  render() {
    const { transs: { loading, error, transactions } } = this.props;

    if (loading) {
      return <div>Loading....</div>;
    }
    if (error) {
      return <Alert> Error occurred while loading data</Alert>;
    }
    return (
      <div>
        <Table>
          <thead>
            <tr>
              <th>ID</th>
              <th>ReferenceID</th>
              <th>MSISDN</th>
              <th>Amount</th>
              <th>Date Time</th>
              <th>3rd Reference</th>
              <th>Orig. TransID</th>
              <th>Client</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((trans) => (
              <tr key={trans.id}>
                <td>{trans.id}</td>
                <td>{trans.referenceid}</td>
                <td>{trans.msisdn}</td>
                <td>{trans.amount}</td>
                <td>{formdate(trans.createdAt)}</td>
                <td>{trans.thirdPartyReference}</td>
                <td>{trans.originatingID}</td>
                <td>{trans.user}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }
}
export default TransactionGQL(TransTable);



// WEBPACK FOOTER //
// ./src/views/Transactions/TransTable.js